module.exports = __webpack_public_path__ + "024dac3c7365bb4261406c2b4a413259.pdf";